<template>
	<div class="ov-input-group">
		<input
			v-if="!multiline"
			class="form-control"
			:value="modelValue"
			:readonly="readonly"
			:placeholder="placeholder"
			@input="$emit('update:modelValue', $event.target.value)"
		/>
		<textarea
			v-else
			class="form-control"
			:value="modelValue"
			:readonly="readonly"
			:placeholder="placeholder"
			:rows="rows"
			@input="$emit('update:modelValue', $event.target.value)"
		/>
		<div v-if="$slots.append" class="ov-input-group__append">
			<slot name="append" />
		</div>
	</div>
</template>

<script>
export default {
	name: "OvInputGroup",
	props: {
		modelValue: { type: String, default: "" },
		readonly: { type: Boolean, default: false },
		placeholder: { type: String, default: "" },
		multiline: { type: Boolean, default: false },
		rows: { type: Number, default: 3 },
	},
	emits: ["update:modelValue"],
};
</script>

<style lang="scss" scoped>
.ov-input-group {
	display: flex;
	align-items: stretch;

	.form-control {
		flex: 1;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}

	&__append {
		display: flex;
		align-items: center;

		:deep(.ov-btn) {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			height: 38px;
		}
	}
}
</style>
